export default __webpack_public_path__ + "static/avatar9-0cc31e3520760c4b0ae671e581d53947.png";